import { render, staticRenderFns } from "./ChangPassword.vue?vue&type=template&id=29349455&scoped=true"
import script from "./ChangPassword.vue?vue&type=script&lang=js"
export * from "./ChangPassword.vue?vue&type=script&lang=js"
import style0 from "./ChangPassword.vue?vue&type=style&index=0&id=29349455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29349455",
  null
  
)

export default component.exports